module.exports = __webpack_public_path__ + "static/media/jobs.e7eb7589.svg";